import { ComponentType, lazy, LazyExoticComponent } from 'react';
import { Application } from '@monorepo/types';
import { CurrencyCodeType, CurrencyIconsMap } from './icons-map';

const usdIcon = lazy(() => import('./icons/usd.icon.svg?react'));

const isIconExists = (code: string) => {
  return Object.keys(CurrencyIconsMap).includes(
    code.toUpperCase() as CurrencyCodeType,
  );
};

export const getIconData = ({
  code,
}: {
  code: string;
  project?: Application;
}): {
  Icon: LazyExoticComponent<ComponentType>;
  code: string;
} => {
  let Icon;

  if (code && isIconExists(code)) {
    Icon = CurrencyIconsMap[code.toUpperCase() as CurrencyCodeType];
  } else {
    Icon = usdIcon;
  }

  return { Icon, code };
};
